import { Component, OnInit } from '@angular/core';
import {BehaviorSubject, combineLatest, Observable} from "rxjs";
import {FilterModel, LeModalService, patternSearch, TableComponent} from "common-shared";
import {map, takeUntil} from "rxjs/operators";
import {ContactQuery, ContactService} from "../contact.service";
import {StateService} from 'web-shared';

@Component({
  selector: 'app-contact-list',
  templateUrl: './contact-list.component.html',
  styles: [
  ]
})
export class ContactListComponent extends TableComponent implements OnInit {
  filteredData$: Observable<ContactQuery[]>;
  offset: number = 0;
  searchString : string;

  constructor(public contactService: ContactService, private modalService: LeModalService, private stateService: StateService) {
    super()
  }

  ngOnInit(): void {
    this.restoreFilterState();
    this.configureFilter();
  }

  private restoreFilterState(): void {
    this.search$ = new BehaviorSubject<string>(null);
    let filterState = this.stateService.getFilterState<ContactQuery>()
    if (filterState === null) {
      filterState = new FilterModel<ContactQuery>();
      this.stateService.setFilterState(filterState);
    }
    this.searchString = filterState.Global;
  }

  configureFilter(): void {
    this.filteredData$ = combineLatest(
      [this.contactService.getAll(), this.search$]
    ).pipe(map(([processes, search]) => {
      this.offset = 0;
      let filterState = this.stateService.getFilterState<ContactQuery>();
      filterState.Global = search;
      this.stateService.setFilterState(filterState);
      return processes.filter(i => {
        const results: boolean[] = [];
        if (search) {
          results.push(patternSearch(search, [i.Code, i.Name]));
        }
        return results.length === 0 || results.indexOf(false) === -1;
      });
    }));
  }

  edit(id: string): void {
    this.contactService.edit(id).pipe(takeUntil(this.componentDestroyed)).subscribe(()=> {
      this.configureFilter();
    });
  }
}
